import {Controller} from "@mecatran-components/controller"
import {StopSelector} from "./stopselector.controller.mjs";
import {DestineoPlanner} from "./destineoplanner.controller.mjs";
import {ScheduleViewer} from "./scheduleviewer.controller.mjs";
import {MapComponent} from "../components/map.component.mjs";
import {SearchBar} from "../components/searchbar.component.mjs";

/* 
TESTING CSS
- Searchbar 
*/

export class ControllerManager extends Controller{
    constructor(view){
        if (!view) throw new Error('ControllerManager. View is mandatory');
        super(view);
        var _school;

        // this.view = view;
        /* ======================================= */
        /* PRIVATE                                 */
        /* ======================================= */
        window.view = view // debug 
        
        this.initControllerManager();

        Object.defineProperty(this,'school',{
            set:(s)=>{ _school = s },
            get:()=>_school
        })
        
    }

    reset(){
        //this.view.removeAllSubComponents()
        this.createStopSelectorController('school');
    }

    onSchoolSelected(stop){
        this.school = stop;
        this.createStopSelectorController('home', stop);
    }

    onBackButton(source, type, schoolStation){
        if (source instanceof StopSelector) {
            if (type === 'home') this.reset();
            return; 
        }
        if (source instanceof ScheduleViewer){
            switch(type){
                case 'school':
                    this.reset();
                    return;
                    break;
                case 'home':
                    //var school = stop; 
                    this.createStopSelectorController('home', schoolStation);
                    break;
            }
        }
        if (source instanceof DestineoPlanner){
            switch(type){
                case 'school':
                    this.reset();
                    break;
                case 'stop':
                    var school = this.school;
                    this.createStopSelectorController('home',school)
                    break;
            }
        }
    }

    /**
     * 
     * @param detail - string ['full-LR','LR','LS']  // note: this is a dependency on StopSelector
     */
     onStopTagSelected(id, schoolStop, homeStop){
        switch(id){
            case 'fullLS':
                this.createScheduleViewerController(schoolStop, homeStop); 
                break;
            case 'LR':
                this.createDestineoPlannerController(schoolStop);
                break;
                /*
            case 'LS':
                this.createScheduleViewerController(stop);
                break; 
                */
        }
    }


    /**
     * 
     * @param type string ['school', 'home' ] [mandatory]
     * @param school Stop [optional ]
     * Note: school is an entry from DestinationIndex (not from ItineraryIndex)
     */
    createStopSelectorController(type, school){
        var mapComponent  = this.getComponent(this.mapName);
        var schoolId = (school) ? school.getId() : undefined ;
        var stopSelector = new StopSelector(this.view, type, schoolId, mapComponent );
        stopSelector.controllerManager = this;
    }

    createDestineoPlannerController(stop){
        var destineoPlanner = new DestineoPlanner(this.view, stop);
        destineoPlanner.controllerManager = this;
        return destineoPlanner;
    }

    createScheduleViewerController(schoolStation, homeStation){
        var scheduleViewerOptions = {
            homeStation  
        };
        var scheduleViewer = new ScheduleViewer(this.view, schoolStation, scheduleViewerOptions);
        scheduleViewer.controllerManager = this;
        return scheduleViewer; 
    }

    createMapComponent(){
        return new MapComponent();
    }

    /*
    createBackButton(){
        return new BackButton();
    }
    */

    createSearchBar(){
        return new SearchBar();
    }

    registerSearchBar(){
        var name = "searchBar";
        this.searchBarName = name;
        this.register(name, this.createSearchBar);
        this.createComponent(name);
    }

    /*
    registerBackButton(){
        var name = "backButton";
        this.backButtonName = name;
        this.register(name, this.createBackButton);
        this.createComponent(name);
    }
    */

    registerMapComponent(){
        var name = "map";
        this.mapName = name;
        this.register(name, this.createMapComponent);
        this.createComponent(name);   
    }

    initControllerManager(){
        this.mapSelector = "#map";  // tmp (selector in the view)

        this.headerPanelSelector = "#header-panel"; 
        this.bodyPanelSelector = "#body-panel"
        this.footerPanelSelector =  "#footer-panel"; 

        this.registerSearchBar();
        this.registerMapComponent();

        this.reset();
        //this.addToView(this.searchBarName, this.headerPanelSelector)
        this.addToView(this.mapName, this.mapSelector)

    }
    
    
}